import { CREATIVE_SCORE_METRIC_NAME, TOTAL_TAGS_METRIC_NAME } from './displayedMetrics';

export const MIN_TOP_METRICS = 3;
export const MAX_TOP_METRICS = 6;

const TICKET_TOP_METRICS = [
  'cost',
  'revenue',
  'results',
  'roas',
  'potential_uplift',
  'potential_savings',
  'cp_result',
  'result_rate',
  'conversion_rate',
  'spend_on_top_performers',
  'spend_on_underperformers',
  'ctr',
  'cpm',
  CREATIVE_SCORE_METRIC_NAME,
  TOTAL_TAGS_METRIC_NAME,
];

export const DEFAULT_TOP_METRICS = [
  'cost',
  'revenue',
  'roas',
  'potential_uplift',
  'potential_savings',
  'ctr',
] as const;

export function ticketMetrics(available: string[]): string[] {
  const answerable = new Set(available);
  return TICKET_TOP_METRICS.filter((name) => answerable.has(name));
}

export interface PickableMetric {
  name: string;
  label: string;
}

export function pruneSelection(selected: string[], available: string[]): string[] {
  const availableNames = new Set(available);
  const kept = selected.filter((name) => availableNames.has(name)).slice(0, MAX_TOP_METRICS);
  if (kept.length >= MIN_TOP_METRICS) return kept;
  const backfill = [
    ...kept,
    ...DEFAULT_TOP_METRICS.filter((name) => availableNames.has(name) && !kept.includes(name)),
    ...available.filter((name) => !kept.includes(name)),
  ];
  return [...new Set(backfill)].slice(0, MAX_TOP_METRICS);
}
